/* eslint-disable */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { Card, CardContent, Typography, makeStyles } from '@material-ui/core'
import {
  Alert,
  Button,
  Snackbar,
  TextInput
} from '@minha-biblioteca/saraiva-ui'
import queryString from 'query-string'
import Bugsnag from '@bugsnag/js'

import BackLink from '../../components/BackLink'
import services from '../../services'
import useStyles from './styles'
import activateTicketImg from './activateTicket.svg'
import { redirectToLogin, isUnauthorized } from '../../auth'
import { PENALTY_LEVEL_CAPTCHA } from '../../constants/PenaltyLevel'
import { usePenalty } from '../../contexts/PenaltyContext'

const useNotificationStyles = makeStyles((theme) => ({
  root: {
    top: 0,
    right: 0,
    marginTop: 88,
    marginRight: 8,
    [theme.breakpoints.down(835)]: {
      marginTop: 72,
      marginRight: 16
    }
  }
}))

export default function ActivateTicket() {
  const classes = useStyles()
  const notificationClasses = useNotificationStyles()
  const { handlePenaltyLevel } = usePenalty()
  const [ticket, setTicket] = useState('')
  const [notifications, setNotifications] = useState([])
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [trackingSent, setTrackingSent] = useState(false)
  const searchValues = queryString.parse(window.location.search)

  useEffect(() => {
    const shouldTrack = !sessionStorage.getItem('ticketPageVisited')
    if (shouldTrack) {
      services.Trackings.visitTicketPage()
      sessionStorage.setItem('ticketPageVisited', 'true')
    }
    
    return () => {
      setNotifications([])
    }
  }, [])

  const createErrorNotifications = (errors) => {
    if (!trackingSent) {
      services.Trackings.ticketActivation({
        ticket,
        status: 'Erro',
        errorMessage: 'Cupom inválido ou expirado.',
        isFirstActivation: !!searchValues['no-access']
      })
      setTrackingSent(true)
    }

    return [
      {
        id: `error-${Date.now()}`,
        show: true,
        message: 'Cupom inválido ou expirado.',
        severity: 'error',
        classes: () => notificationClasses
      }
    ]
  }

  const activateTicket = async () => {
    if (loading) {
      return
    }

    setTrackingSent(false)
    
    setNotifications([])

    const payload = {
      user_id: services.Users.getUserId(),
      code: ticket,
      activated_at: new Date()
        .toISOString()
        .replace(/T/, ' ')
        .replace(/\..+/, '')
    }

    let snackbars = []

    setLoading(true)

    try {
      const response = await services.Tickets.activateTicket(payload)

      if (isUnauthorized(response.status)) {
        redirectToLogin()
        return
      }

      if (response.status === 403) {
        const responseText = await response.text()
        if (responseText === 'penalty_level_1') {
          handlePenaltyLevel(PENALTY_LEVEL_CAPTCHA)
          return
        }
      }

      if (!response.ok) {
        let errors = {}
        try {
          const responseData = await response.json()
          errors = responseData.errors || { general: 'Erro desconhecido' }
        } catch (parseError) {
          errors = { general: 'Erro ao processar resposta do servidor' }
        }

        snackbars = createErrorNotifications(errors)
      } else {
        snackbars = [
          {
            id: `success-${Date.now()}`,
            show: true,
            message: 'Cupom ativado com sucesso.',
            severity: 'success',
            classes: () => notificationClasses
          }
        ]

        if (!trackingSent) {
          services.Trackings.ticketActivation({
            ticket,
            status: 'Ativado',
            isFirstActivation: !!searchValues['no-access']
          })
          setTrackingSent(true)
        }

        setTimeout(() => {
          setRedirect(true)
        }, 3000)
      }
    } catch (err) {
      console.error('Erro ao ativar ticket:', err)
      Bugsnag.notify(err)

      snackbars = [
        {
          id: `catch-error-${Date.now()}`,
          show: true,
          message: 'Erro de conexão. Verifique sua internet e tente novamente.',
          severity: 'error',
          classes: () => notificationClasses
        }
      ]
    } finally {
      setNotifications(snackbars)
      setLoading(false)
    }
  }

  const closeSnackbar = (notification) => {
    const openNotifications = notifications.filter(
      (notif) => notif.id !== notification.id
    )

    setNotifications(openNotifications)
  }

  const renderBackLink = () => {
    if (searchValues['no-access']) {
      return null
    }

    return <BackLink />
  }

  const redirectToHome = () => <Redirect to="/" />

  const renderPageContent = () => {
    return (
      <div className={classes.main}>
        {notifications.map((notification) => (
          <Snackbar
            show={notification.show}
            severity={notification.severity}
            handleClose={() => closeSnackbar(notification)}
            classes={notification.classes}
            key={notification.id}
            autoHideDuration={3000}
          >
            {notification.message}
          </Snackbar>
        ))}

        {renderBackLink()}

        <Card variant="outlined" className={classes.root}>
          <CardContent className={classes.wrapper}>
            <div className={classes.mainContent}>
              <Typography className={classes.title}>
                Bem-vindo ao Leme!
              </Typography>

              <Typography variant="body1" className={classes.description}>
                Insira o cupom repassado pela administração da sua Biblioteca
                Digital e acesse os livros do Leme.
              </Typography>

              <div className={classes.alert}>
                <Alert severity="info">
                  Caso você não tenha um código de cupom, entre em contato com a
                  administração de sua Biblioteca Digital.
                </Alert>
              </div>

              <TextInput
                color="primary"
                size="full"
                label="Insira o código de cupom"
                onChange={(evt) => setTicket(evt.target.value)}
                value={ticket}
              />

              <div className={classes.button}>
                <Button
                  color="primary"
                  disabled={ticket.length === 0 || loading}
                  variant="contained"
                  onClick={activateTicket}
                  fullWidth
                >
                  Ativar Cupom
                </Button>
              </div>
            </div>

            <div className={classes.imageContainer}>
              <img
                src={activateTicketImg}
                alt="Figura de uma mulher sentada em uma cadeira utilizando um computador"
              />
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }

  return redirect ? redirectToHome() : renderPageContent()
}

ActivateTicket.propTypes = {
  marginTopDesktop: PropTypes.number,
  marginTopMobile: PropTypes.number
}

ActivateTicket.defaultProps = {
  marginTopDesktop: 24,
  marginTopMobile: 24
}
